/**
 * @author gyb(mocheer)
 * @email mocheer@foxmail.com  
 * @since 2017.6.12
 */
import Tool from './Tool'
import MilitaryArrow from '@/marker/MilitaryArrow'
//
let { LatLng } = L;
/**
 * 军标箭头
 */
export default class MilitaryArrowTool extends Tool {
  options = { feature: { fillColor: 'red', weight: 1, fillOpacity: .5, color: '#333' } }
  /**
   * 启动
   */
  start() {
    this.onMouseDown = this.onMouseDown.bind(this)
    this.onMouseMove = this.onMouseMove.bind(this)
    let { map } = this;
    map.on('mousedown', this.onMouseDown);
    this.restart = true;
  }
  /**
   * 取消
   */
  cancel() {
    let { map } = this;
    map.off('mousedown', this.onMouseDown);
    map.off('mousemove', this.onMouseMove);
    this.mp = null;
  }
  /**
   * 绘制
   */
  onMouseDown(e) {
    this.reset();
    //
    let { marker, map, layer, options } = this;
    let { feature } = options;
    let { latlng } = e;
    //
    if (!marker) {
      feature.draggable = false;
      // feature.interactive = false;
      marker = this.marker = new MilitaryArrow([latlng], feature).addTo(layer)
      map.on('mousemove', this.onMouseMove);
      map.once('dblclick', this.onEnd.bind(this))
    } else {
      this.mp = null;
    }
    this.lp = e.layerPoint
  }
  /**
   * 
   * @param e 
   */
  onMouseMove(e) {
    let { marker, mp } = this,
      { latlng, layerPoint } = e,
      latlngs = marker.getLatLngs();
    if (!mp) {
      let { lp } = this;
      marker.addLatLng(latlng);
      this.mp = latlng;
    } else {
      mp.lat = latlng.lat;
      mp.lng = latlng.lng;
      // marker.getBounds().extend(mp)
      marker.redraw();
    }
  }
}


// WEBPACK FOOTER //
// ./src/plugins/tools/MilitaryArrowTool.js